// temporary solution to support both versions of sidebar, should be deleted once all roots migrate to new sidebar
import { sidebarConfig } from '@ovpn/ui/sidebar';
import { breakpoint } from '@ovpn/ui/tokens';

import { isTrue } from '@sso/shared/utils';

const legacyBreakPoints = {
    XS: 575,
    SM: 768,
    MD: 992,
    LG: 1200,
    XLG: 1366,
};

const newSidebarConfig = {
    transition: `padding-left ${sidebarConfig.transitionDuration}ms;`,
    mobile: breakpoint.sm - 1,
    tablet: breakpoint.md - 1,
};

const oldSidebarConfig = {
    transition: `padding-left ${sidebarConfig.transitionDuration}ms cubic-bezier(0.4, 0, 0.6, 1) 30ms`,
    mobile: legacyBreakPoints.SM,
    tablet: legacyBreakPoints.MD,
};

export const config = (() =>
    isTrue(window._env_?.NEW_SIDEBAR) ? newSidebarConfig : oldSidebarConfig)();
